"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1Stronger: function() {
        return _index.Body1Stronger;
    },
    body1StrongerClassNames: function() {
        return _index.body1StrongerClassNames;
    }
});
const _index = require("./components/presets/Body1Stronger/index");
